module.exports = __webpack_public_path__ + "img/aex.bdb6ecc2.svg";